import { Flex, Modal, Text } from "@mantine/core";
import dayjs from "dayjs";
import { useMemo } from "react";

import { type IMedHistoryItem } from "./MedHistory.types";
import MedHistoryRow from "./MedHistoryRow";

interface Props {
  opened: boolean;
  onClose: () => void;
  tag: string;
  data?: IMedHistoryItem[];
}

const getLabel = (tag: string) => {
  let el = document.querySelector(`div.${tag}`) as HTMLElement;
  while (el && el.nodeName !== "TR") {
    el = el.parentNode as HTMLElement;
  }
  if (!el || el.nodeName !== "TR") return "";
  return el.firstChild?.firstChild?.firstChild?.textContent;
};

const MedHistoryModal = ({ opened, onClose, tag, data }: Props) => {
  const modalTitle = useMemo(
    () =>
      getLabel(tag)?.includes("History")
        ? getLabel(tag)
        : `${getLabel(tag)} History`,
    [tag],
  );
  return (
    <Modal opened={opened} onClose={onClose} title={modalTitle}>
      {data && data.length > 0 ? (
        data.map(h => (
          <Flex key={h.date} direction="column">
            <Text>{dayjs(h.date).format("D MMM YYYY HH:mm")}</Text>
            <Flex ml="sm" direction="column">
              {h.rows.map((r, i) => (
                <MedHistoryRow key={i} row={r} />
              ))}
            </Flex>
          </Flex>
        ))
      ) : (
        <Text ta="center" c="gray">
          No items
        </Text>
      )}
    </Modal>
  );
};

export default MedHistoryModal;
